<template>
  <div>
    <b-row v-for="(anotacao, index) in anotacoes"
           :key="index">
      <b-col cols="3">
        <label class="impressao--label"
               for="">
          Tipo de anotação:
        </label>
        <select v-model="anotacao.tipo_documento"
                class="mb-2 form-control form-control-sm"
                size="sm"
                @change="changeTipo(anotacao,index),changeAnotacao(anotacao)">
          <option v-for="(option, index) in optionsAnotacao"
                  :key="index"
                  :disabled="option.disabled"
                  :value="option.value">
            {{ option.text }}
          </option>
        </select>
      </b-col>
      <b-col v-if="['rg', 'cns', 'pis_nis', 'passaporte', 'cnh', 'ctps', 'reservista'].indexOf(anotacao.tipo_documento) != '-1'"
             cols="8">
        <b-row>
          <b-col cols="3">
            <label class="impressao--label"
                   for="numero">Número</label>
            <input id="numero"
                   v-model="anotacao.numero"
                   class="form-control form-control-sm"
                   type="tel"
                   :placeholder="placeholder"
                   :maxlength="maxlength"
                   :class="{'is-invalid':errors.has(`anotacao_numero_${anotacao.tipo_documento}`)}"
                   :name="`anotacao_numero_${anotacao.tipo_documento}`"
                   @change="changeAnotacao(anotacao)">
          </b-col>
          <b-col v-if="anotacao.tipo_documento == 'ctps' || anotacao.tipo_documento == 'passaporte'"
                 cols="3">
            <label class="impressao--label"
                   for="serie">Série </label>
            <input id="serie"
                   v-model="anotacao.serie"
                   class="form-control form-control-sm"
                   type="tel"
                   :class="{'is-invalid':errors.has(`anotacao_serie_${anotacao.tipo_documento}`)}"
                   :name="`anotacao_serie_${anotacao.tipo_documento}`"
                   @change="changeAnotacao(anotacao)">
          </b-col>
          <b-col v-if="['passaporte', 'reservista', 'cnh', 'pis_nis', 'cns', 'ctps'].indexOf(anotacao.tipo_documento) == -1"
                 cols="3">
            <label class="impressao--label"
                   for="codigo_orgao_emissor">Órgão Emissor</label>
            <select id="codigo_orgao_emissor"
                    v-model="anotacao.codigo_orgao_emissor"
                    class="form-control form-control-sm"
                    name="codigo_orgao_emissor"
                    @change="changeAnotacao(anotacao), updateOrgao()">
              <option v-for="orgao in orgaoEmissorOptions"
                      :key="orgao.codigo"
                      :value="orgao.codigo">
                {{ orgao.descricao }}
              </option>
            </select>
          </b-col>
          <b-col v-if="['rg', 'ctps'].indexOf(anotacao.tipo_documento) !== -1"
                 cols="2">
            <label class="impressao--label"
                   for="uf_emissor">UF Emissor</label>

            <select v-model="anotacao.uf_emissor"
                    class="form-control form-control-sm"
                    :class="{'is-invalid':errors.has('anotacao_uf_emissor')}"
                    name="anotacao_uf_emissor"
                    @change="changeCidades(anotacao.uf_emissor), changeAnotacao(anotacao)">
              <option v-for="state in selectsOptions.states"
                      :key="`state_${state.uf}`"
                      :value="state.codigo">
                {{ state.uf }}
              </option>
            </select>
          </b-col>
          <b-col v-if="['reservista', 'pis_nis', 'cns'].indexOf(anotacao.tipo_documento) == -1"
                 cols="4">
            <label class="impressao--label"
                   :for="`data_emissao_${ _uid }`">Data Emissão</label>
            <input :id="`data_emissao_${ _uid }`"
                   v-model="anotacao.data_emissao"
                   v-validate="`date_format:yyyy-MM-dd|date_between:${ dataInicial() },${ dataLimite() }, (include)`"
                   class="form-control form-control-sm"
                   type="date"
                   placeholder="09/08/2019"
                   :class="{'is-invalid':errors.has(`anotacao_data_emissao_${anotacao.tipo_documento}`)}"
                   :name="`anotacao_data_emissao_${anotacao.tipo_documento}`"
                   @change="changeAnotacao(anotacao)">
          </b-col>
          <b-col v-if="['ctps', 'reservista', 'rg', 'passaporte', 'cnh', 'pis_nis', 'cns'].indexOf(anotacao.tipo_documento) == -1"
                 cols="3">
            <label class="impressao--label"
                   for="data_validade">Data Validade</label>
            <input id="data_validade"
                   v-model="anotacao.data_validade"
                   v-validate="`date_format:yyyy-MM-dd|after:${ dataInicial() }, (include)`"
                   class="form-control form-control-sm"
                   type="date"
                   :class="{'is-invalid':errors.has(`anotacao_data_validade_${anotacao.tipo_documento}`)}"
                   :name="`anotacao_data_validade_${anotacao.tipo_documento}`"
                   @change="changeAnotacao(anotacao)">
          </b-col>
        </b-row>
      </b-col>

      <b-col v-if="anotacao.tipo_documento === 'titulo'"
             cols="8">
        <b-row>
          <b-col cols="3">
            <label class="impressao--label"
                   for="numero_titulo">Número</label>
            <input id="numero_titulo"
                   v-model="anotacao.numero"
                   class="form-control form-control-sm"
                   type="text"
                   :class="{'is-invalid': errors.has('anotacao_numero_titulo')}"
                   name="anotacao_numero_titulo"
                   @change="changeAnotacao(anotacao)">
          </b-col>
          <b-col cols="4">
            <label class="impressao--label"
                   :for="`data_emissao_${ _uid }`">Data Emissão</label>
            <input :id="`data_emissao_${ _uid }`"
                   v-model="anotacao.data_emissao"
                   v-validate="`date_format:yyyy-MM-dd|date_between:${ dataInicial() },${ dataLimite() }, (include)`"
                   class="form-control form-control-sm"
                   type="date"
                   placeholder="09/08/2019"
                   :class="{'is-invalid': errors.has(`anotacao_data_emissao_${anotacao.tipo_documento}`)}"
                   :name="`anotacao_data_emissao_${anotacao.tipo_documento}`"
                   @change="changeAnotacao(anotacao)">
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="anotacao.tipo_documento == 'cep'"
             cols="8">
        <b-row>
          <b-col cols="3">
            <label class="impressao--label"
                   for="numero_cep">CEP</label>
            <input id="numero_cep"
                   v-model="anotacao.numero"
                   v-mask="'99999-999'"
                   type="text"
                   :class="{'is-invalid':errors.has('anotacao_cep')}"
                   name="anotacao_cep"
                   class="form-control form-control-sm"
                   @change="changeAnotacao(anotacao)">
          </b-col>
        </b-row>
      </b-col>
      <b-col v-if="anotacao.tipo_documento == 'grupo_sanguineo'"
             cols="8">
        <b-row>
          <b-col cols="3">
            <label class="impressao--label"
                   for="numero">Grupo Sanguíneo</label>
            <select v-model="anotacao.grupo_sanguineo"
                    :class="{'is-invalid':errors.has('anotacao_grupo_sanguineo')}"
                    name="anotacao_grupo_sanguineo"
                    class="form-control form-control-sm"
                    @change="changeAnotacao(anotacao)">
              <option :value="null">
                Selecione
              </option>
              <option value="A+">
                A+
              </option>
              <option value="A-">
                A-
              </option>
              <option value="B+">
                B+
              </option>
              <option value="B-">
                B-
              </option>
              <option value="AB+">
                AB+
              </option>
              <option value="AB-">
                AB-
              </option>
              <option value="O+">
                O+
              </option>
              <option value="O-">
                O-
              </option>
            </select>
          </b-col>
        </b-row>
      </b-col>

      <b-col cols="1"
             align-self="center"
             class="mt-4">
        <b-button v-if="(index == 0 && anotacao.tipo_documento != null) || (index > 0)"
                  size="sm"
                  variant="light"
                  @click="deletarAnotacao(anotacao,index)">
          <svg class="obito-show_icon icon--sm"
               role="presentation">
            <use :xlink:href="'#' + deleteRedIcon.id" />
          </svg>
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
  import moment from "moment"

  /* icons */
  import deleteRedIcon from '@/assets/icons/delete-red.svg?sprite'

  export default {
    name: 'FormAnotacoesCadastro',
    props: {
      propAnotacoes: {type: Array, default: () => ([])},
      propOptionsAnotacao: {type: Array, default: () => ([])},
      propSelectsOptions: {type: Object, default: () => ({})},
      propMaxLength: {type: String, default: '20'},
      propPlaceholder: {type: String, default: ''},
      propOrgaoEmissorOptions: {type: Array, default: () => ([])},
    },
    data () {
      return {
        anotacoes: [],
        optionsAnotacao: [],
        limitDate: moment(new Date()).add(1, 'day').format('DD/MM/YYYY'),
        selectsOptions: {},
        maxlength: '20',
        placeholder: '',
        orgaoEmissorOptions: [],
        deleteRedIcon
      }
    },
    watch: {
      propAnotacoes () {
        this.anotacoes = this.propAnotacoes
      },
      propOptionsAnotacao () {
        this.optionsAnotacao = this.propOptionsAnotacao
      },
      propSelectsOptions () {
        this.selectsOptions = this.propSelectsOptions
      },
      propMaxLength () {
        this.maxlength = this.propMaxLength
      },
      propPlaceholder () {
        this.placeholder = this.propPlaceholder
      },
      propOrgaoEmissorOptions () {
        this.orgaoEmissorOptions = this.propOrgaoEmissorOptions
      }
    },
    mounted () {
      this.anotacoes = this.propAnotacoes
      this.optionsAnotacao = this.propOptionsAnotacao
      this.selectsOptions = this.propSelectsOptions
      this.maxlength = this.propMaxLength
      this.placeholder = this.propPlaceholder
    },
    methods: {
      changeTipo () {
        this.$emit('changeTipo', true)
      },
      changeAnotacao (anotacao) {
        this.$emit('changeAnotacao', anotacao)
      },
      deletarAnotacao (anotacao,index) {
        this.$emit('deleteAnotacao', anotacao, index)
      },
      updateOrgao () {
        this.$emit('updateOrgao', true)
      },
      changeCidades (uf_emissor) {
        this.$emit('changeCidades', uf_emissor)
      },
      dataLimite () {
        return moment(this.limitdate).format("YYYY-MM-DD")
      },
      dataInicial () {
        return moment('1500/01/01').format("YYYY-MM-DD")
      },
    }
  }
</script>
